<template>
    <div>
    <h2 class="title is-size-4">{{ this.label }} ({{ garment_total_qty }} garments)</h2>
      
<table :id="table_name" class="table is-hoverable is-fullwidth is-size-7">
        <thead>
          <tr>
            <th width="60"></th>
            <th>PO Number</th>
            <th>Customer</th>
            <th>Location</th>
            <th>Garment</th>
            <th>Design Name</th>
            <th>Qty</th>
            <th>CAD ID</th>
            <th>Artworker</th>
            <th @click="updateSortOrder('orderdate')" style="cursor:pointer">Ordered
              <span v-if="order_by === 'orderdate DESC'">&#8595;</span>
              <span v-if="order_by === 'orderdate ASC'">&#8593;</span>
            </th>
            <th @click="updateSortOrder('deliverydate')" style="cursor:pointer">Delivery
              <span v-if="order_by === 'deliverydate DESC'">&#8595;</span>
              <span v-if="order_by === 'deliverydate ASC'">&#8593;</span>
            </th>
            <th>Print Location</th>
            <th>Artwork</th>
            <th>Print</th>
            <th>Trans</th>
            <th>Cut</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="loading === true">
                <td colspan="16" ><div class="notification is-info">Loading orders ...</div></td>
            </tr>
            <tr v-if="loading == false && orders.length == 0">
                <td colspan="16" ><div class="notification is-warning">There are no orders to show</div></td>
            </tr>
          <tr class="" v-for="order in orders" v-bind:key="order.orderID">
            <td><a :href="ASP_URL + '/printorder.asp?txtPONumber=' + order.ponumber" target="_blank"><button class="button is-small is-info" :disabled="working===true" >Print</button></a></td>
            <td><a :href="'/printing-cutting/view-order?ponumber=' + order.ponumber" class="" target="_blank">{{order.ponumber}}</a></td>
            <td>{{order.clientname}}</td>
            <td>{{ displayClientLocationName(order.clientLocationID)}}</td>
          <td>{{order.garmentname}}</td>
          <td>{{order.designname}}</td>
            <td>{{ order.total_qty }}</td>
            <td>{{order.cad_id}}</td>
            <td>
              <div v-if="order.artworker_user_id > 0" >{{ order.artworker_firstname }} {{order.artworker_surname}}</div>
            </td>
            <td>{{order.orderdate}}</td>
            <td>{{order.deliverydate}}</td>
            <td>
              <div class="buttons has-addons ">
                    <button class="button is-small is-success"  v-for="row in locations" :key="row.id" v-show="order.print_location_id==row.id">{{ row.name }}</button>
                </div>
            </td>
            <td>
              <span class="icon has-text-success" v-if="order.artwork_completed==1"><i class="fa fa-check"></i></span>
            </td>
            <td>
              <span class="icon has-text-success" v-if="order.artwork_printed_paper==1"><i class="fa fa-check"></i></span>
            </td>
            <td>
              <span class="icon has-text-success" v-if="order.artwork_printed_rolls==1"><i class="fa fa-check"></i></span>
            </td>
            <td>
              <span class="icon has-text-success" v-if="order.digital_print_cutting==1"><i class="fa fa-check"></i></span>
            </td>
          </tr>
          </tbody>
        </table>

        <table :id="table_name + '-excel'" class="table is-hoverable is-fullwidth is-size-7" style="display:none">
        <thead>
          <tr>
            <th>PO Number</th>
            <th>Customer</th>
            <th>Location</th>
            <th>Garment</th>
            <th>Design Name</th>
            <th>Qty</th>
            <th>CAD ID</th>
            <th>Artworker</th>
            <th >Ordered
              </th>
            <th >Delivery
               </th>
            <th>Print Location</th>
            <th>Artwork</th>
            <th>Print</th>
            <th>Trans</th>
            <th>Cut</th>
          </tr>
        </thead>
        <tbody>
          
          <tr class="" v-for="order in orders" v-bind:key="order.orderID">
            
            <td>{{order.ponumber}}</td>
            <td>{{order.clientname}}</td>
            <td>{{ displayClientLocationName(order.clientLocationID)}}</td>
          <td>{{order.garmentname}}</td>
          <td>{{order.designname}}</td>
            <td>{{ order.total_qty }}</td>
            <td>{{order.cad_id}}</td>
            <td>
              <div v-if="order.artworker_user_id > 0" >{{ order.artworker_firstname }} {{order.artworker_surname}}</div>
            </td>
            <td>{{order.orderdate_iso}}</td>
            <td>{{order.deliverydate_iso}}</td>
            <td>
              
                   {{ showLocationName(order.print_location_id) }}
                
            </td>
            <td>
              <span class="icon has-text-success" v-if="order.artwork_completed==1">Yes</span>
            </td>
            <td>
              <span class="icon has-text-success" v-if="order.artwork_printed_paper==1">Yes</span>
            </td>
            <td>
              <span class="icon has-text-success" v-if="order.artwork_printed_rolls==1">Yes</span>
            </td>
            <td>
              <span class="icon has-text-success" v-if="order.digital_print_cutting==1">Yes</span>
            </td>
          </tr>
          </tbody>
        </table>
        
        <button @click="exportXLS(table_name)" class="button is-success mb-2" >Export to Excel</button>
        <hr />
       
</div>
    </template>

<script>
import XLSX from 'xlsx';

import OrderMixin from "@/mixins/OrderMixin.js";

export default {
  mixins: [OrderMixin],
    data() {
      return {
        count: 0,
        working: false,
        order_by: 'deliverydate ASC',
        ASP_URL : process.env.VUE_APP_ASP_URL,
      }
    },
    name: 'SchedulerOrdersTable',
    props: ['orders', 'loading', 'label', 'locations', 'table_name'],
    computed: {
      garment_total_qty: function() {
        let total = this.orders.reduce(function (previousValue, currentValue) {
            return previousValue + currentValue.total_qty;
          }, 0);

          return total;
      },
    },
    methods: {
      exportXLS(table) {

      var wb = XLSX.utils.book_new();
      wb.SheetNames.push("Orders");
      var ws1 = XLSX.utils.table_to_sheet(document.getElementById(table + '-excel')); // Removed , {raw:true}
      wb.Sheets["Orders"] = ws1;

      XLSX.writeFile(wb, 'Scheduler Export.xlsx');


      },
      showLocationName(print_location_id) {
        const result = this.locations.filter(location => location.id == print_location_id)
        if(result.length > 0)
        {
          return result[0].name
        }
        else{
          return ""
        }
      },
    }
  }
  </script>